var o = typeof window != "undefined" ? window : {};
export {
  o as global
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/global.js
// module id = 835
// module chunks = 41